'use strict';

const $ = require('jquery');

class sideMenu {

    constructor() {

        const $sideMenu = $('[data-side-menu]');
        const $chapters = $('[data-chapter]');

        if ($sideMenu.length > 0 && $chapters.length > 0) {

            const $floatingMenu = $('.floating-menu');
            const $floatingMenuList = $floatingMenu.find('ul');

            let headerHeight = $('#header').height();
            let floatingMenuTop = $floatingMenu.offset().top;
            let floatingMenuLeft = $floatingMenu.parent().offset().left;
            let floatingMenuWidth;
            let Timer;
            let hash = window.location.hash;

            //  Generate menu based on elements
            $chapters.each(function () {

                let $this = $(this);
                let chapterType = $this.data('chapter'); // main | sub
                let chapterTitle = $this.data('chapter-title');
                let link = $this.attr('id');

                $floatingMenuList.append(`<li><a href="#${link}" class="readspeaker__read">${chapterTitle}</a></li>`);

            });

            //  Add handler for clicking the menu
            $floatingMenuList.on('click', 'a', (event) => {
                event.preventDefault();

                let $this = $(event.currentTarget);
                let target = $this.attr('href');

                this.scrollToTarget(target);
            });

            //  Calculate the width of the floating menu wrapper
            App.Globals.$window
                .on('load resize', function () {

                    floatingMenuWidth = $floatingMenu.parent().width();
                    floatingMenuLeft = $floatingMenu.parent().offset().left;

                    $floatingMenu.css({
                        'width': floatingMenuWidth,
                        'left': floatingMenuLeft
                    });

                })
                .on('load scroll', function () {

                    let windowTop = App.Globals.$window.scrollTop();

                    //  Loop through all the items to check which one is currently in the viewport
                    $chapters.each(function () {

                        let $this = $(this);

                        if ((windowTop + headerHeight + 40) >= $this.offset().top) {

                            //  Remove all 'selected' classes from the floating menu
                            $floatingMenu.find('a').removeClass('selected');

                            //  Add class 'selected' to the currently in view product
                            let $target = $('[href="#' + $this.attr('id') + '"]');

                            $target.addClass('selected');

                        }

                    });

                    if ((windowTop + 90) >= floatingMenuTop) {

                        //  Add classname to body when window height (+ header height) passes the top
                        //  offset of the floating menu
                        App.Globals.$body.addClass('scrolled');

                    } else {

                        //  Reset the body class
                        App.Globals.$body.removeClass('scrolled');

                    }

                    //  Check for reaching bottom
                    if ((windowTop + 90 + $floatingMenu.outerHeight()) >= ($floatingMenu.parent().offset().top + $floatingMenu.parent().height())) {

                        App.Globals.$body.addClass('scrolled-bottom');

                    } else {

                        App.Globals.$body.removeClass('scrolled-bottom');

                    }

                    //  Wait until the user stops scrolling and change the url
                    clearTimeout(Timer);
                    Timer = setTimeout(function () {

                        let currentId = $floatingMenu.find('a.selected').attr('href');

                        if (typeof currentId !== 'undefined') {

                            window.history.pushState(null, null, currentId);

                        }

                    }, 50);

                });

            if (hash && hash.indexOf('#') !== -1) {

                this.scrollToTarget(hash);

            }

        }

    }

    /**
     *
     * @param target
     */
    scrollToTarget(target) {

        let headerHeight = $('#header').height();
        let targetTop = $(target).offset().top;

        //  For mobile: close the menu
        App.Globals.$body.removeClass('floating-menu-open');

        App.Globals.$scrollAnimators.animate({
            scrollTop: targetTop - headerHeight - 20
        });

    }

}

module.exports = sideMenu;
